<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 権限（利用者グループ）

    .register-value.show-message-radios(v-if="0 < _value.length")
      .list-container.d-flex.flex-row.justify-content-center.align-items-center.flex-wrap
        .resident-group-list.d-flex.flex-column
          .list-body
            .resident(v-for="group in _value" :key="group.id").d-flex.flex-row
              b-form-checkbox(v-model="group.isTarget")
              span {{ group.name }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputPermissionResidentGroup extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  private value!: Array<PermissionResidentGroupModel>;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): Array<PermissionResidentGroupModel> {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: Array<PermissionResidentGroupModel>) {
    this.$emit("input", newValue);
    return;
  }
}

export interface PermissionResidentGroupModel {
  groupId: number;
  name: string;
  isTarget: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.resident-group-list {
  width: 610px;
  max-height: 240px;

  // デフォルトフォントサイズを指定する
  font-size: 16px;
  // 外枠はここで描画させる
  border: solid 1px $form-border-color;

  .list-body {
    overflow-y: scroll;
    overflow-x: auto;
    .resident {
      padding: 8px;
      border-bottom: solid 1px $border-lightgray;
    }
  }
}
</style>
